import React, { useEffect, useState, useRef } from 'react';
import { Container, CircularProgress, Typography, Paper, Toolbar, Button, Grid, Divider } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from "react-redux";
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux';
import { IdentityActions, TerminalActions, NotificationActions } from '../../../store';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        fontSize: '18px'
    },
    infoTitle: {
        "& h3": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 0 auto'
        }
    },
    table: {
        "& td": {
            paddingRight: '10px'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const terminalsSelector = (state) => state.Terminals;
const IdentitySelector = (state) => state.Identity;

const TerminalDetail = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const terminalActions = bindActionCreators(TerminalActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(terminalsSelector);
    const { token, permissions } = useSelector(IdentitySelector);

    const { classes } = props;

    // 削除確認ダイアログ表示フラグ
    const [ dlgOpen, setDlgOpen ] = React.useState(false);

    /**
     * 
     * 戻るボタン押下時の処理
     * 
     */
    const onBackClick = () => {
        props.onCancel();
    }

    /**
     * 
     * 編集ボタン押下時の処理
     * 
     */
    const onEditClick = () => {
        props.onEdit();
    }

    /**
     *
     * 削除ボタン押下時の処理
     *
     */
    const onDeleteClick = () => {
        // 削除確認ダイアログを表示
        setDlgOpen(true);
    };

    /**
     * 
     * 撤去ボタン押下時の処理
     * 
     */
    const onRemovalClick = () => {
        terminalActions.removal(token, editing)
            .then(data => {
                notificationActions.showSuccess('撤去しました。');
                props.onCancel();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 削除確認ダイアログでの「はい」ボタン押下時の処理（削除実行）
     * 
     */
    const onDlgYesClick = () => {
        // 一旦、削除確認ダイアログを閉じる
        setDlgOpen(false);
        // 端末削除処理を実行
        terminalActions.delete(token, editing)
            .then(data => {
                notificationActions.showSuccess('削除しました。');
                props.onCancel();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 削除確認ダイアログでの「いいえ」ボタン押下時の処理（キャンセル）
     *
     */
    const onDlgNoClick = () => {
        // 削除確認ダイアログを閉じる
        setDlgOpen(false);
    };

    var editButton = <div style={{ height: 40 }}></div>;
    var deleteButton = <div></div>; 
    if (permissions.fid5_4 != null && (permissions.fid5_4.value.value & 2) == 2) {
        // 端末編集権限：有り
        if (!editing.is_installed) {
            // 未設置の場合は編集ボタン
            editButton =
                <div>
                    <Button fullWidth id="editButton" variant="contained" size="medium" color="primary"
                        endIcon={<EditIcon />}
                        onClick={onEditClick}>編集</Button>
                </div>;
            // 未設置の場合は削除ボタン
            deleteButton =
                <Grid item xs={3} sm={6}>
                    <Button fullWidth variant="contained" size="medium" color="secondary"
                        startIcon={<DeleteForeverIcon />}
                        onClick={onDeleteClick}>削除</Button>
                </Grid>;
        }
        else {
            // 設置済の場合は撤去ボタン
            deleteButton =
                <Grid item xs={3} sm={6}>
                    <Button fullWidth variant="contained" size="medium" color="secondary"
                        startIcon={<HighlightOffIcon />}
                        onClick={onRemovalClick}>撤去</Button>
                </Grid>;
        }
    }

    // 端末タイプ
    var terminalType = "";
    if (editing.terminal_type == 1) {
        terminalType = "ステッカー";
    }
    else if (editing.terminal_type == 2) {
        terminalType = "QR";
    }
    else if (editing.terminal_type == 3) {
        terminalType = "カード";
    }
    else if (editing.terminal_type == 4) {
        terminalType = "QRカード";
    }

    // 機種コード
    var machineModelCd = "";
    if (editing.machine_model_cd == "1071") {
        machineModelCd = "係員型";
    }
    else if (editing.machine_model_cd == "1071") {
        machineModelCd = "顧客型";
    }

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Toolbar variant="regular">
                    <div>
                        <Typography component="h1" variant="inherit">端末</Typography>
                    </div>
                </Toolbar>

                <form className={classes.form}>
                    <Grid container spacing={2} justify="center">
                        <Grid item xs={12}>
                            <div className={classes.infoTitle}>
                                <Typography id="infoTitle" component="h3" variant="inherit">端末情報</Typography>
                                {editButton}
                            </div>

                            <Divider />
                        </Grid>

                        <Grid item xs={12}>
                            <table className={classes.table}>
                                <tbody>
                                    <tr><td><FormattedMessage id="Terminal.Id" /></td><td>{editing.id}</td></tr>
                                    <tr><td><FormattedMessage id="Terminal.Shop" /></td><td>{editing.shop_name}</td></tr>
                                    <tr><td><FormattedMessage id="Terminal.TerminalType" /></td><td>{terminalType}</td></tr>
                                    <tr><td><FormattedMessage id="Terminal.InstallId" /></td><td>{editing.install_id}</td></tr>
                                    <tr><td><FormattedMessage id="Terminal.Merchant.Name" /></td><td>{editing.merchant_name}</td></tr>
                                    <tr><td><FormattedMessage id="Terminal.MachineModelCd" /></td><td>{editing.machine_model_cd}</td></tr>
                                    <tr><td><FormattedMessage id="Terminal.MachineId" /></td><td>{editing.machine_id}</td></tr>
                                    <tr><td><FormattedMessage id="Terminal.ApplyStartDate" /></td><td>{editing.apply_start_dt}</td></tr>
                                    <tr><td><FormattedMessage id="Terminal.ApplyStopDate" /></td><td>{editing.apply_stop_dt}</td></tr>
                                    <tr><td><FormattedMessage id="Terminal.IsCharge" /></td><td>{editing.is_charge == true ? <FormattedMessage id="Terminal.IsCharge.Available" /> : <FormattedMessage id="Terminal.IsCharge.Notavailable" />}</td></tr>
                                    <tr><td><FormattedMessage id="Terminal.ShopCd4" /></td><td>{editing.shop_cd_4}</td></tr>
                                    <tr><td><FormattedMessage id="Terminal.IsInstalled" /></td><td>{editing.is_installed == false ? <FormattedMessage id="Terminal.IsInstalled.Notinstalled" /> : <FormattedMessage id="Terminal.IsInstalled.Installed" />}</td></tr>
                                    <tr><td><FormattedMessage id="Terminal.MerchantOrgInfo" /></td><td>{editing.merchant_org_info}</td></tr>
                                </tbody>
                            </table>
                        </Grid>

                        <Grid container item xs={12} spacing={2} justify="center">
                            <Grid item xs={3} sm={6}>
                                <Button fullWidth variant="contained" size="medium"
                                    startIcon={<ArrowBackIosIcon />}
                                    onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                            </Grid>
                            {deleteButton}
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}

            <Dialog
                open={dlgOpen}
                onClose={onDlgNoClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"確認"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        端末情報を削除しますか？
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onDlgYesClick} color="primary">
                        はい
                    </Button>
                    <Button onClick={onDlgNoClick} color="primary" autoFocus>
                        いいえ
                    </Button>
                </DialogActions>
            </Dialog>

        </Container>
    )    
}

export default withStyles(style, { withTheme: true })(TerminalDetail);